// Copyright (c) 2021. Sendanor <info@sendanor.fi>. All rights reserved.

import * as React from "react";
import "./FormValueListView.scss";
import FormAppClassName from "../../../../../constants/FormAppClassName";
import FormService from "../../../../../services/FormService";
import LogService from "../../../../../nor/ts/LogService";
import RepositoryEntry from "../../../../../nor/ts/simpleRepository/types/RepositoryEntry";
import FormValueDTO from "../../../../../nor/ui/types/FormValueDTO";
import {
    get,
    pathsToScalarItems,
    map,
    forEach
} from "../../../../../nor/ts/modules/lodash";
import Loader from "../../../../../nor/ui/components/loader/Loader";

const LOG = LogService.createLogger('FormValueListView');

export interface FormValueListViewProps {
    readonly className  ?: string;
    readonly id          : string;
    readonly hasSession  : boolean;
}

export interface FormValueListViewState {

    readonly loaded : boolean;
    readonly list   : RepositoryEntry<FormValueDTO>[];

}

export class FormValueListView extends React.Component<FormValueListViewProps, FormValueListViewState> {

    public static defaultProps: Partial<FormValueListViewProps> = {};

    private _loading : boolean;

    public constructor (props: FormValueListViewProps) {

        super(props);

        this._loading = false;

        this.state = {
            loaded : false,
            list   : []
        };

    }

    public componentDidMount (): void {

        this._loadFormValues();

    }

    public render () {

        const list = this.state.list;

        const tablePaths : string[] = [];
        forEach(
            list,
            (item : any) => {
                const itemPaths : string[] = pathsToScalarItems(item);
                forEach(itemPaths, (path : string) => {
                    if (!tablePaths.includes(path)) {
                        tablePaths.push(path);
                    }
                });
            }
        );

        LOG.debug(`tablePaths = `, tablePaths);

        return (
            <div className={FormAppClassName.FORM_VALUE_LIST_VIEW + ' ' + (this.props.className ?? '')}>

                <header className={FormAppClassName.FORM_VALUE_LIST_VIEW + '-header'}>

                    <h1 className={FormAppClassName.FORM_VALUE_LIST_VIEW + '-header-title'}>Entries</h1>

                    <div className={FormAppClassName.FORM_VALUE_LIST_VIEW + '-header-buttons'}>

                    {/*{this.props.hasSession ? (*/}

                    {/*        <Button*/}
                    {/*            click={this._addNewFormCallback}*/}
                    {/*            className={FormAppClassName.FORM_VALUE_LIST_VIEW + '-header-add-form-button'}*/}
                    {/*        ><Icon><AddIcon /></Icon> Add new form</Button>*/}

                    {/*) : null}*/}

                    </div>

                </header>

                <section className={FormAppClassName.FORM_VALUE_LIST_VIEW + '-content'}>

                    {this.props.hasSession ? (
                        <React.Fragment>

                            {this.state.loaded ? (
                                <React.Fragment>

                                    <table className={FormAppClassName.FORM_VALUE_LIST_VIEW + '-list'}>

                                        <thead>
                                            <tr>{map(tablePaths, (path, columnIndex) => {

                                                return (
                                                    <th
                                                        key={`thead-column-${path}`}
                                                        className={FormAppClassName.FORM_VALUE_LIST_VIEW + `-form-${path}`}
                                                    >{path}</th>
                                                );

                                            })}</tr>
                                            <tr></tr>
                                        </thead>

                                        <tbody>{map(list, (item : RepositoryEntry<FormValueDTO>, rowIndex: number) => {
                                        const id = item.data.formId;
                                        // const valueId = item.id;
                                        return (
                                            <tr key={`tbody-row-${id}`}
                                                className={FormAppClassName.FORM_VALUE_LIST_VIEW + '-form'}>

                                                {map(tablePaths, (path, columnIndex) => {
                                                    const value = get(item, path, '');
                                                    return (
                                                        <td
                                                            key={`tbody-row-${id}-column-${path}`}
                                                            className={FormAppClassName.FORM_VALUE_LIST_VIEW + `-form-${path}`}
                                                        >{value}</td>
                                                    );
                                                })}

                                                <td>
                                                    {/*<Link to={AppRoute.FORM_VALUE_LIST_VIEW + '/' + id + '/entries/' + valueId }*/}
                                                    {/*      className={FormAppClassName.FORM_VALUE_LIST_VIEW + '-button'}>*/}
                                                    {/*    <Icon><ListIcon /></Icon>*/}
                                                    {/*    <span className={FormAppClassName.FORM_VALUE_LIST_VIEW + '-button-text'}>View</span>*/}
                                                    {/*</Link>*/}
                                                </td>

                                            </tr>
                                        );
                                        })}</tbody>

                                    </table>

                                    {this.state.list.length === 0 ? (
                                        <p>No entries.</p>
                                    ) : null}

                                </React.Fragment>
                            ) : (
                                <Loader className={FormAppClassName.FORM_VALUE_LIST_VIEW + '-loader'} />
                            )}

                        </React.Fragment>
                    ) : (
                        <p><strong>You need to login first.</strong></p>
                    )}

                </section>

            </div>
        );

    }

    private _loadFormValues () {

        if (!this.props.hasSession) {
            LOG.warn(`Warning! User has not logged in. Cannot load forms.`);
            return;
        }

        if (this._loading) {
            LOG.warn(`Warning! Page already loading.`);
            return;
        }

        this._loading = true;

        FormService.getFormValueList(this.props.id).then( (list) => {
            this._loading = false;
            LOG.debug(`Loaded list: `, list);
            this.setState({
                loaded: true,
                list: list
            });
        }).catch( (err) => {

            this._loading = false;

            LOG.error(`Error: `, err);

            // FIXME: Show error message

        });

    }

}

export default FormValueListView;
